
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5297',
  depVersions: {
  "data-privacy-request-ui": "static-1.5297",
  "data-fetching-client": "static-1.9449",
  "head-dlb": "static-1.4754",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7776",
  "hub-http-shared-msw-handlers": "static-1.9406",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11192",
  "I18n": "static-7.1562",
  "jasmine-runner": "static-1.6243",
  "privacy-center-public-service-types": "static-1.4560",
  "quartz": "static-1.6687",
  "react-dlb": "static-1.71",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5330",
  "UIComponents": "static-3.8139",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.81",
  "foundations-assets": "static-1.4605",
  "foundations-components": "static-1.7466",
  "foundations-components-test-utils": "static-1.4949",
  "foundations-theming": "static-1.4180",
  "hub-http": "static-1.5966",
  "quartz-config": "static-1.465",
  "quartz-core": "static-1.5906",
  "quick-fetch": "static-1.3707",
  "raven": "static-3.5624",
  "react": "static-7.177",
  "react-rhumb": "static-1.16412",
  "SharedI18nStrings": "static-1.180",
  "ui-addon-i18n": "static-1.10903",
  "usage-tracker": "static-1.7103",
  "usage-tracker-anonymous": "static-1.5520",
  "usage-tracker-core": "static-1.6953",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3917",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3201",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2964",
  "quartz-webpack": "static-1.2911",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.77",
  "HeadJS": "static-2.704",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2887",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "ts-schema": "static-1.3878",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "react-utils": "static-2.5146",
  "StyleGuideUI": "static-3.483",
  "jasmine": "static-4.4100",
  "rpc-client-utils": "static-1.4404",
  "HubStyle": "static-2.11500",
  "ui-addon-draggable": "static-3.4536",
  "cssUtils": "static-1.725",
  "hs-story-utils": "static-1.9199",
  "icons": "static-2.618",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.94",
  "ui-images": "static-2.1085",
  "bend-plugin-foundations-components": "static-1.3735",
  "floating-ui": "static-1.51",
  "foundations-theming-specialty": "static-1.1896",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1114",
  "ui-fonts": "static-1.454",
  "bend-plugin-foundations-theming": "static-1.2663",
  "foundations-theming-base": "static-1.3165",
  "stylex": "static-1.27",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.787",
  "hubspotter-http": "static-1.4451",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.362",
  "quartz-head": "static-1.352",
  "quartz-i18n": "static-1.362",
  "quartz-routing": "static-1.117",
  "quartz-test": "static-1.362",
  "usage-tracker-container": "static-1.7093",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2910",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.65",
  "sassPrefix": "static-1.151",
  "hubspotter-http-shared-msw-handlers": "static-1.9404"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5297",
  "data-fetching-client": "/data-fetching-client/static-1.9449",
  "head-dlb": "/head-dlb/static-1.4754",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7776",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9406",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11192",
  "I18n": "/I18n/static-7.1562",
  "jasmine-runner": "/jasmine-runner/static-1.6243",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4560",
  "quartz": "/quartz/static-1.6687",
  "react-dlb": "/react-dlb/static-1.71",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5330",
  "UIComponents": "/UIComponents/static-3.8139",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "foundations-assets": "/foundations-assets/static-1.4605",
  "foundations-components": "/foundations-components/static-1.7466",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4949",
  "foundations-theming": "/foundations-theming/static-1.4180",
  "hub-http": "/hub-http/static-1.5966",
  "quartz-config": "/quartz-config/static-1.465",
  "quartz-core": "/quartz-core/static-1.5906",
  "quick-fetch": "/quick-fetch/static-1.3707",
  "raven": "/raven/static-3.5624",
  "react": "/react/static-7.177",
  "react-rhumb": "/react-rhumb/static-1.16412",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10903",
  "usage-tracker": "/usage-tracker/static-1.7103",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5520",
  "usage-tracker-core": "/usage-tracker-core/static-1.6953",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3201",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2964",
  "quartz-webpack": "/quartz-webpack/static-1.2911",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.77",
  "HeadJS": "/HeadJS/static-2.704",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2887",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "ts-schema": "/ts-schema/static-1.3878",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "react-utils": "/react-utils/static-2.5146",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "jasmine": "/jasmine/static-4.4100",
  "rpc-client-utils": "/rpc-client-utils/static-1.4404",
  "HubStyle": "/HubStyle/static-2.11500",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4536",
  "cssUtils": "/cssUtils/static-1.725",
  "hs-story-utils": "/hs-story-utils/static-1.9199",
  "icons": "/icons/static-2.618",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.94",
  "ui-images": "/ui-images/static-2.1085",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3735",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1896",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1114",
  "ui-fonts": "/ui-fonts/static-1.454",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2663",
  "foundations-theming-base": "/foundations-theming-base/static-1.3165",
  "stylex": "/stylex/static-1.27",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "hubspotter-http": "/hubspotter-http/static-1.4451",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.362",
  "quartz-head": "/quartz-head/static-1.352",
  "quartz-i18n": "/quartz-i18n/static-1.362",
  "quartz-routing": "/quartz-routing/static-1.117",
  "quartz-test": "/quartz-test/static-1.362",
  "usage-tracker-container": "/usage-tracker-container/static-1.7093",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2910",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.65",
  "sassPrefix": "/sassPrefix/static-1.151",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9404"
}
};
